// Mega Menu Enhancement Script
document.addEventListener('DOMContentLoaded', () => {
  const enhanceMegaMenuHover = () => {
    document.querySelectorAll('header-menu').forEach(menu => {
      const details = menu.querySelector('details');
      const summary = menu.querySelector('summary');
      const content = menu.querySelector('.mega-menu__content');
      const slider = menu.querySelector('.mega-menu__slider');
      
      if (!details || !summary || !content) return;
      
      let timeoutId = null;
      let isInteractingWithSlider = false;
      
      // Open menu on hover
      summary.addEventListener('mouseenter', () => {
        details.setAttribute('open', '');
        clearTimeout(timeoutId);
      });
      
      // Keep menu open when hovering over content
      content.addEventListener('mouseenter', () => {
        clearTimeout(timeoutId);
      });
      
      // Handle slider interactions
      if (slider) {
        slider.addEventListener('mousedown', (e) => {
          e.stopPropagation();
          isInteractingWithSlider = true;
          clearTimeout(timeoutId);
          details.setAttribute('open', '');
        });
        
        slider.addEventListener('mouseup', () => {
          setTimeout(() => {
            isInteractingWithSlider = false;
          }, 300);
        });
        
        // Prevent clicks on slider elements from closing the menu
        slider.querySelectorAll('button, .slider').forEach(el => {
          el.addEventListener('click', e => {
            e.stopPropagation();
            details.setAttribute('open', '');
          });
        });
        
        slider.addEventListener('mouseleave', () => {
          isInteractingWithSlider = false;
        });
      }
      
      // Close menu when leaving the entire menu area, unless interacting with slider
      details.addEventListener('mouseleave', () => {
        if (!isInteractingWithSlider) {
          timeoutId = setTimeout(() => {
            details.removeAttribute('open');
          }, 200);
        }
      });
    });
  };
  
  const initMegaMenuSliders = () => {
    document.querySelectorAll('.mega-menu__slider').forEach(slider => {
      const sliderContainer = slider.querySelector('.slider');
      const slides = slider.querySelectorAll('.slider__slide');
      const prevButton = slider.querySelector('.slider-button--prev');
      const nextButton = slider.querySelector('.slider-button--next');
      const counterCurrent = slider.querySelector('.slider-counter--current');
      const counterTotal = slider.querySelector('.slider-counter--total');
      
      if (!sliderContainer || !slides.length || !prevButton || !nextButton) return;
      
      const slideWidth = slides[0].offsetWidth;
      const totalSlides = slides.length;
      let currentIndex = 0;
      
      if (counterTotal) {
        counterTotal.textContent = totalSlides;
      }
      
      const updateSlider = () => {
        const offset = -currentIndex * slideWidth;
        sliderContainer.style.transform = `translateX(${offset}px)`;
        sliderContainer.style.transition = 'transform 0.3s ease';
        
        if (counterCurrent) {
          counterCurrent.textContent = ((currentIndex % totalSlides) + 1);
        }
      };
      
      prevButton.addEventListener('click', e => {
        e.stopPropagation();
        currentIndex = (currentIndex - 1 + totalSlides) % totalSlides;
        updateSlider();
      });
      
      nextButton.addEventListener('click', e => {
        e.stopPropagation();
        currentIndex = (currentIndex + 1) % totalSlides;
        updateSlider();
      });
      
      window.addEventListener('resize', () => {
        updateSlider();
      });
      
      updateSlider();
    });
  };
  
  // Close menu when clicking outside
  document.addEventListener('click', (e) => {
    const openMenus = document.querySelectorAll('header-menu details[open]');
    openMenus.forEach(details => {
      const menu = details.closest('header-menu');
      if (!menu.contains(e.target)) {
        details.removeAttribute('open');
      }
    });
  });

  enhanceMegaMenuHover();
  setTimeout(initMegaMenuSliders, 100);
});

// IMPORTANT: Check if DetailsDisclosure is already defined before declaring it
if (!customElements.get('details-disclosure')) {
  class DetailsDisclosure extends HTMLElement {
    constructor() {
      super();
      this.mainDetailsToggle = this.querySelector('details');
      if (!this.mainDetailsToggle) return;
      
      this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;
      if (!this.content) return;
      
      this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
      this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
    }
    
    onFocusOut() {
      setTimeout(() => {
        // Prevent closing if the active element is within the slider or content
        const slider = this.querySelector('.mega-menu__slider');
        if (slider && slider.contains(document.activeElement)) return;
        if (!this.contains(document.activeElement)) this.close();
      });
    }
    
    onToggle() {
      if (!this.animations) {
        try {
          this.animations = this.content.getAnimations();
        } catch(e) {
          this.animations = [];
          console.warn('Could not get animations:', e);
        }
      }
      
      if (this.mainDetailsToggle.hasAttribute('open')) {
        this.animations.forEach((animation) => animation.play());
      } else {
        this.animations.forEach((animation) => animation.cancel());
      }
    }
    
    close() {
      this.mainDetailsToggle.removeAttribute('open');
      const summary = this.mainDetailsToggle.querySelector('summary');
      if (summary) {
        summary.setAttribute('aria-expanded', false);
      }
    }
  }
  
  customElements.define('details-disclosure', DetailsDisclosure);
}

// Only define HeaderMenu if it doesn't already exist
if (!customElements.get('header-menu')) {
  class HeaderMenu extends DetailsDisclosure {
    constructor() {
      super();
      this.header = document.querySelector('.header-wrapper');
    }
    
    onToggle() {
      if (!this.header) return;
      this.header.preventHide = this.mainDetailsToggle.open;
      
      if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
      
      document.documentElement.style.setProperty(
        '--header-bottom-position-desktop',
        `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
      );
    }
  }
  
  customElements.define('header-menu', HeaderMenu);
}